module.exports = __webpack_public_path__ + "media/src/application/media/img2-acf1352e946281899774953cc9b50166.jpg";